export const seoConfig = {
	'/': {
		title: 'Clevory Academy | Centre de Formation IT en Tunisie',
		description:
			'Découvrez Clevory Academy, centre de formation IT en Tunisie. Formateurs experts, programmes certifiants et accompagnement vers l’emploi.',
	},

	'/qui-sommes-nous': {
		title: 'Clevory Academy | Centre de Formation Informatique en Tunisie',
		description:
			'Découvrez nos formations en intelligence artificielle en Tunisie : agentic IA, IA générative et IT Sales. Programmes pratiques et certifiants.',
	},

	'/formations': {
		title:
			'Formation Intelligence Artificielle en Tunisie | Formation IT Sales | Clevory Academy',
		description:
			'Apprenez l’intelligence artificielle avec Clevory Academy : IA générative, IT Sales et projets concrets. Inscrivez-vous dès maintenant.',
	},

	'/formations/agentic-ia': {
		title:
			'Formation Agentic IA en Tunisie | IA Générative & Agents | Clevory Academy',
		description:
			'Maîtrisez l’IA générative et les agents intelligents avec notre formation Agentic IA en Tunisie. Projets concrets, outils modernes, inscription ouverte.',
	},

	'/formations/it-sales': {
		title:
			'Formation IT Sales en Tunisie | Vente de Solutions IT | Clevory Academy',
		description:
			'Apprenez à vendre des solutions IT et SaaS avec notre formation IT Sales en Tunisie. Techniques de vente, prospection et closing. Inscription ouverte.',
	},

	'/formations/formation-a-la-carte': {
		title: 'Formation en informatique | IA Générative | Clevory Academy',
		description:
			'Consultez le calendrier des formations à la carte en Tunisie avec Clevory Academy. Sessions flexibles, programmes personnalisés et inscription ouverte.',
	},

	'/calendrier': {
		title: 'Calendrier des Formations IT en Tunisie | Clevory Academy',
		description:
			'Consultez le calendrier des prochaines formations en informatique, intelligence artificielle, Clevory Academy en Tunisie. Dates, sessions et inscriptions ouvertes.',
	},

	'/contact': {
		title: 'Contact Clevory Academy | Centre de Formation IT en Tunisie',
		description:
			'Contactez Clevory Academy pour vos formations IT en Tunisie : intelligence artificielle, python, cloud et IA. Réponse rapide, inscription ouverte.',
	},
};
